<template>
    <v-text-field
      v-model="employee_code"
      class="text-xs-center"
      :label="input_label"
      outlined
      append-icon="search"
      @click="check_default()"
      @click:append="validate_code()"
      @keyup.enter="validate_code()"
      @change="validate_code()"
      @input="clear()"
        maxlength="6" :disabled="loadSearch"
      :loading="loadSearch"
      dense :hide-details="hide_details"
    >
    </v-text-field>
  </template>
  <script>
  export default {
    name: "FindEmployee",
    props: {
      hide_details: {
        type: Boolean,
        default: false,
      },
      label_description: {
        type: String,
        default: 'Codigo de empleado',
      },
      default_input: {
        type: String,
      },
    },
    data: () => ({
      codeRule: [(v) => /^([0-9])*$/.test(v) || "Codigo no valido!"],
      employee_code: null,
      employee_fullname:null,
      loadSearch: false,
    }),
  
    computed: {
        input_label(){
            if(this.employee_fullname==null){
                return this.label_description;
            }
          return  `${this.label_description}: ${this.employee_fullname}`;
        }
    },
    mounted(){
        if(this.default_input!=null){
            this.employee_code=this.default_input;
        }
    },
    methods: {
      check_default(){
            if(this.employee_code!=null && this.employee_code==this.default_input){
                return this.employee_code=null;
            }
        },
      async validate_code() {
        if (this.employee_code == "" || this.employee_code == null) {
            this.$toast.warning("El codigo no puede estar vacio!");
            return;
        }
        if (/^([0-9])*$/.test(this.employee_code) == false) { 
            this.$toast.warning('Codigo no valido!'); 
            return 
        }
        this.employee_fullname=null;
        try {
          this.loadSearch = true;
         // this.$emit("loading", true);
          const result = await this.api_Post("shopping/validate_applicant", {
            employee_code: this.clearInputFilter(this.employee_code, 6),
          });
          const data = await result.json();
          if (result.status == 200) {
            if ((await data.length) == 0) {
              this.infoNotification("No se encontraron resultados!");
              this.loadSearch = false;
             // this.$emit("loading", false);
              return;
            }
            if (parseInt(data[0].employee_status_id) >= 4) {
              this.$toast.warning("Este empleado no se encuentra activo!");
              this.loadSearch = false;
             // this.$emit("loading", false);
              return;
            }
            this.employee_fullname= data[0].employee_fullname;
            this.employee_code =data[0].employee_code;           
        
            this.$emit("set-employee", {
              employee_id: data[0].employee_id,
              employee_fullname: data[0].employee_fullname,
              employee_code: data[0].employee_code,
              entity_id: data[0].entity_id
            });
          } else {
            this.$toast.error(data.error);
          }
        } catch (error) {
            this.$toast.error(error);
        }
        this.loadSearch = false;
      //  this.$emit("loading", false);
      },
      clear() {
          this.$emit("clear", true);
      },
    },
  };
  </script>
  
  
  